import { render, staticRenderFns } from "./Person-to-notif-relationship.vue?vue&type=template&id=0542512e"
import script from "./Person-to-notif-relationship.vue?vue&type=script&lang=js"
export * from "./Person-to-notif-relationship.vue?vue&type=script&lang=js"
import style0 from "./Person-to-notif-relationship.vue?vue&type=style&index=0&id=0542512e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports